import React from 'react';
import classNames from 'classnames/bind';
import styles from './PageTitle.module.scss';

const cx = classNames.bind(styles);
function HostPageTitle(props) {
  const { title } = props;

  return (
    <h2 className={cx('title')} {...props}>
      {title}
    </h2>
  );
}

export default HostPageTitle;
